/* torras-ss-hero.js —— 从 sections/torras-ss-hero.liquid 的内联 <script> 原样外置。
 *
 * 为什么外置：该 section 原本 1,480 行，其中 1,241 行是这段**零 Liquid 插值**的静态 JS，
 * 每次页面渲染都随 HTML 重新下发、完全不可缓存。搬到 assets/ 后浏览器可缓存，
 * 且 section 文件从 1,480 行降到约 240 行。
 *
 * 时序不变：这段代码结尾本来就在等 DOMContentLoaded（见文件末），配 defer 引入后
 * 执行点仍在 DOM 解析完成之后，且能拿到比原先（内联在页面中段）**更全**的 DOM。
 *
 * ⚠️ 取舍（记录在案）：首次访问多一个网络往返才可交互。可接受的理由是该页 markup 由
 * Liquid 服务端渲染（第一个 model block 的卡片默认可见），没有 JS 时是"有内容、暂不可筛选"，
 * 不是空白。若判断不划算，把本文件内容贴回 section 内联即可，一行回退。
 * 相关记录：memory `section-js-boot-immediately`（警告 {% javascript %} 的延迟包会让
 * JS 组装的 UI 空白 —— 本例不适用，因为 markup 是服务端渲染的）。
 *
 * 内容与原内联块**逐字节一致**，改动前请先确认这一点仍成立。
 */
(function(){
  'use strict';
  if(window.__tSSInit) return; window.__tSSInit=true;
  function init(){

  /* ---------- 2. Device picker (brand tabs + search + grouped list) ---------- */
  /* Replaces the old sliding-pill strip. The lineup spans several SERIES today and will
     span several BRANDS, which a one-line strip can't present. Ported from the approved
     device-switcher comp: a Brand|Model trigger opening a searchable panel (a bottom sheet
     under 749px). Each .tds-item carries data-model (block id | "all") and data-label (the
     device name), which is exactly the contract applyModel() already consumes. */
  var tds = document.querySelector('[data-tds]');
  var tdsItems = tds ? Array.prototype.slice.call(tds.querySelectorAll('.tds-item')) : [];
  function selectedModelOption(){
    for(var i = 0; i < tdsItems.length; i++){
      if(tdsItems[i].getAttribute('data-active') === 'true') return tdsItems[i];
    }
    return tdsItems[0] || null;
  }
  if(tds){
    var tdsOpeners = Array.prototype.slice.call(tds.querySelectorAll('[data-tds-open]'));
    var tdsClose   = tds.querySelector('[data-tds-close]');
    var tdsSearch  = tds.querySelector('[data-tds-search]');
    var tdsEmpty   = tds.querySelector('[data-tds-empty]');
    var tdsTabs    = Array.prototype.slice.call(tds.querySelectorAll('[data-tds-tab]'));
    var tdsGroups  = Array.prototype.slice.call(tds.querySelectorAll('[data-tds-group]'));
    var tdsBrandV  = tds.querySelector('[data-tds-brandval]');
    var tdsModelV  = tds.querySelector('[data-tds-modelval]');
    var tdsOpen = false;

    function tdsActiveTab(){
      for(var i = 0; i < tdsTabs.length; i++){
        if(tdsTabs[i].getAttribute('data-active') === 'true') return tdsTabs[i].getAttribute('data-tds-tab');
      }
      return tdsTabs.length ? tdsTabs[0].getAttribute('data-tds-tab') : null;
    }
    function tdsApplyTab(slug){
      tdsTabs.forEach(function(t){ t.setAttribute('data-active', t.getAttribute('data-tds-tab') === slug ? 'true' : 'false'); });
      /* With no tab row (a single-brand lineup) every group stays visible. */
      tdsGroups.forEach(function(g){ g.hidden = tdsTabs.length ? (g.getAttribute('data-tds-group') !== slug) : false; });
    }
    /* Search spans the whole list and ignores the brand tabs — typing "pixel" while the
       Apple tab is active should still find it, so the tab row hides while searching. */
    function tdsFilter(q){
      q = (q || '').trim().toLowerCase();
      if(!q){
        tds.classList.remove('is-searching');
        tdsItems.forEach(function(i){ i.hidden = false; });
        if(tdsTabs.length){ tdsApplyTab(tdsActiveTab()); } else { tdsGroups.forEach(function(g){ g.hidden = false; }); }
        if(tdsEmpty) tdsEmpty.setAttribute('data-show', 'false');
        return;
      }
      tds.classList.add('is-searching');
      var any = false;
      tdsItems.forEach(function(i){
        var m = (i.getAttribute('data-name') || '').indexOf(q) > -1;
        i.hidden = !m;
        if(m) any = true;
      });
      tdsGroups.forEach(function(g){ g.hidden = g.querySelectorAll('.tds-item:not([hidden])').length === 0; });
      if(tdsEmpty) tdsEmpty.setAttribute('data-show', any ? 'false' : 'true');
    }
    function tdsSetOpen(o){
      tdsOpen = o;
      tds.classList.toggle('is-open', o);
      tdsOpeners.forEach(function(b){ b.setAttribute('aria-expanded', o ? 'true' : 'false'); });
      if(o){
        requestAnimationFrame(function(){
          /* Focusing the search field on a touch device pops the keyboard over the sheet,
             so only steal focus where there's a hardware keyboard. */
          if(tdsSearch && window.matchMedia && window.matchMedia('(min-width: 750px)').matches){
            try{ tdsSearch.focus(); }catch(e){}
          }
          var cur = tds.querySelector('.tds-item[data-active="true"]');
          if(cur){ try{ cur.scrollIntoView({ block: 'nearest' }); }catch(e){} }
        });
      } else if(tdsSearch){ tdsSearch.value = ''; tdsFilter(''); }
    }
    function tdsSelect(item){
      if(!item) return;
      tdsItems.forEach(function(i){
        var on = i === item;
        i.setAttribute('data-active', on ? 'true' : 'false');
        if(on){ i.setAttribute('aria-current', 'true'); } else { i.removeAttribute('aria-current'); }
      });
      if(tdsModelV){ tdsModelV.textContent = item.getAttribute('data-label') || item.textContent.trim(); }
      if(tdsBrandV && item.getAttribute('data-brand')){ tdsBrandV.textContent = item.getAttribute('data-brand'); }
      applyModel(item); /* hoisted from the builder block below */
      tdsSetOpen(false);
    }

    tdsOpeners.forEach(function(b){ b.addEventListener('click', function(){ tdsSetOpen(!tdsOpen); }); });
    if(tdsClose) tdsClose.addEventListener('click', function(){ tdsSetOpen(false); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && tdsOpen) tdsSetOpen(false); });
    document.addEventListener('click', function(e){ if(tdsOpen && !tds.contains(e.target)) tdsSetOpen(false); });
    tdsTabs.forEach(function(t){
      t.addEventListener('click', function(){
        if(tdsSearch) tdsSearch.value = '';
        tdsApplyTab(t.getAttribute('data-tds-tab'));
        tdsFilter('');
      });
    });
    if(tdsSearch) tdsSearch.addEventListener('input', function(){ tdsFilter(tdsSearch.value); });
    tdsItems.forEach(function(i){ i.addEventListener('click', function(){ tdsSelect(i); }); });
  }

  /* ---------- 3. Bundle builder + tier discount ---------- */
  var TIERS = [
    {min:3, pct:0.15, label:'3+ items · −15%'},
    {min:2, pct:0.12, label:'2 items · −12%'},
    {min:1, pct:0.10, label:'1 item · −10%'}
  ];
  var grid = document.getElementById('tss-grid');
  var cards = {};
  /* Rebuilt, not just populated: chips can inject cards fetched through the Section
     Rendering API, which replaces DOM nodes. Anything holding a stale element
     reference (the picked-state repaint, retargetCard, the swatch handlers) would
     silently operate on a detached node otherwise. */
  function indexCards(){
    cards = {};
    grid.querySelectorAll('.card[data-id]').forEach(function(c){ cards[c.dataset.id] = c; });
  }
  indexCards();
  var selected = []; // array of ids, in click order
  /* Snapshot of what was actually added (variant/price/name/img at add-time) — cases are
     ONE product with Device × Color variants, so the live card retargets its variant when
     the model tab or swatch changes; the bundle must keep what the shopper committed. */
  var selectedMeta = {};
  var currentDevice = ''; // active tab label = the Device option value to resolve against

  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  /* Resolve a swatch to a concrete variant id: shared-device cases carry a
     {"iPhone 17 Pro Max": id, "iPhone 17 Pro": id} map per color. */
  /* deviceWanted lets a RECEIPT line resolve against the device IT is committed to rather
     than whatever the picker currently shows — otherwise changing a line's colour would
     silently drag it back to the active model. Omitted = use the active model. */
  function resolveVariant(sw, deviceWanted){
    var want = deviceWanted || currentDevice;
    if(sw.getAttribute('data-vmap')){
      try{
        var map = JSON.parse(sw.getAttribute('data-vmap'));
        if(want && map[want]) return String(map[want]);
        for(var k in map){ return String(map[k]); }
      }catch(err){}
    }
    return sw.dataset.variant;
  }
  /* Every colour this card offers FOR `device`, and which one is live. A colour is not
     sold for every device, so the receipt's colour select has to be scoped the same way
     the card's swatch row is — otherwise a line committed to iPhone 15 Pro Max still
     lists Lava Red and picking it resolves to a 16 Pro Max variant. Falls back to every
     swatch when the card has no vmap (single-device product) or no device is known. */
  function colorInfo(card, device){
    var sws = Array.prototype.slice.call(card.querySelectorAll('[data-sw]'));
    if(!sws.length) return { label: '', options: [] };
    var fits = function(sw){
      var raw = sw.getAttribute('data-vmap');
      if(!raw || !device) return true;
      try{ return !!JSON.parse(raw)[device]; }catch(err){ return true; }
    };
    var usable = sws.filter(fits);
    if(!usable.length) usable = sws;
    var on = card.querySelector('[data-sw].on');
    if(!on || usable.indexOf(on) < 0) on = usable[0];
    return {
      label: on.dataset.label || '',
      options: usable.map(function(x){ return x.dataset.label || ''; }).filter(Boolean)
    };
  }
  /* Which swatch can actually serve `device`. A colour is NOT offered for every
     device — Ostand Q3 Spin is Pearl White on 17 Pro but only Clear / Obsidian on
     17 — so each swatch's vmap covers just the devices that colour exists for.
     Keep the shopper's colour when it covers the device, else take the first that
     does; null when none can. */
  function swatchFor(card, device){
    if(!device) return null;
    var sws = Array.prototype.slice.call(card.querySelectorAll('[data-sw]'));
    if(!sws.length) return null;
    var covers = function(sw){
      var raw = sw.getAttribute('data-vmap');
      if(!raw) return false;
      try{ return !!JSON.parse(raw)[device]; }catch(err){ return false; }
    };
    var on = card.querySelector('[data-sw].on');
    if(on && covers(on)) return on;
    for(var i = 0; i < sws.length; i++){ if(covers(sws[i])) return sws[i]; }
    return null;
  }
  /* Show only the colours that exist for `device`. A swatch's vmap lists exactly the
     devices that colour is buyable for, so a swatch with no entry for the selected
     phone is not a choice at all — leaving it on screen offered Lava Red (a 16 Pro
     Max-only colour) on the iPhone 15 Pro Max tab, and clicking it could only land on
     another model's case. No vmap = a single-device product, every colour applies. */
  function syncSwatches(card, device){
    var sws = card.querySelectorAll('[data-sw]');
    if(!sws.length) return;
    Array.prototype.forEach.call(sws, function(sw){
      var raw = sw.getAttribute('data-vmap');
      if(!raw || !device){ sw.hidden = false; return; }
      var ok = true;
      try{ ok = !!JSON.parse(raw)[device]; }catch(err){}
      sw.hidden = !ok;
    });
  }
  function retargetCard(card){
    syncSwatches(card, currentDevice);
    var on = card.querySelector('[data-sw].on');
    if(!on) return;
    /* A colour with no variant for the selected phone must not silently resolve to a
       DIFFERENT phone's variant — resolveVariant falls through to the map's first key,
       which put an iPhone 17 Pro Max case in the bundle while the iPhone 17 tab was
       open. Device correctness outranks colour preference: the shopper chose the
       phone, the colour is a preference we can move. selectSwatch repaints the
       image / price / name to match. */
    var want = swatchFor(card, currentDevice);
    if(want && want !== on){ selectSwatch(want); return; }
    card.dataset.variant = resolveVariant(on);
  }
  /* Which device this line is for, and whether the shopper can change it on the receipt.
     Three cases, and only the first is switchable in place:
       1. shared-device case (swatch carries a data-vmap of Device → variant id) — every key
          in the map is a real alternative, so offer them all;
       2. per-device SKU (the card lives under exactly one model tab) — "changing model"
          means a different product, which is what the model tabs above already do;
       3. universal accessory (several tabs, no Device option) — no model to print. */
  function tabLabel(blockId){
    var o = tds && tds.querySelector('.tds-item[data-model="' + blockId + '"]');
    return o ? (o.getAttribute('data-label') || o.textContent.trim()) : '';
  }
  function cardFamily(card){
    var raw = card.getAttribute('data-family');
    if(!raw) return null;
    try{
      var fam = JSON.parse(raw);
      return (fam && fam.length > 1) ? fam : null;
    }catch(err){ return null; }
  }
  function deviceInfo(card){
    /* (1) one product, real Device option — the swatch's vmap resolves it. */
    var on = card.querySelector('[data-sw].on') || card.querySelector('[data-sw]');
    if(on && on.getAttribute('data-vmap')){
      try{
        var map = JSON.parse(on.getAttribute('data-vmap'));
        var keys = Object.keys(map);
        var cur = (currentDevice && map[currentDevice]) ? currentDevice : keys[0];
        if(keys.length){ return { label: cur, options: keys, kind: 'vmap' }; }
      }catch(err){}
    }
    /* (2) protector family — sibling PRODUCTS via custom.variation_products. */
    var fam = cardFamily(card);
    if(fam){
      var self = card.dataset.device || '';
      var hit = fam.filter(function(f){ return f.d === self; })[0] || fam[0];
      return { label: hit.d, options: fam.map(function(f){ return f.d; }), kind: 'family' };
    }
    /* (3) a single-model SKU with no family recorded — print it, nothing to switch to. */
    if(card.dataset.device){ return { label: card.dataset.device, options: [], kind: '' }; }
    var owners = (card.dataset.model || '').split(/\s+/).filter(Boolean);
    if(owners.length === 1){ return { label: tabLabel(owners[0]), options: [], kind: '' }; }
    /* (4) universal accessory — no model to print. */
    return { label: '', options: [], kind: '' };
  }
  function snapshot(card){
    var img = card.querySelector('[data-card-img]');
    var dev = deviceInfo(card);
    /* Scope the colours to the device this line is being committed to, not the tab
       that happens to be open — they differ once a line's model is changed on the
       receipt. */
    var col = colorInfo(card, dev.label);
    selectedMeta[card.dataset.id] = {
      variant: card.dataset.variant,
      price: parseFloat(card.dataset.price),
      /* With a colour switcher on the line, the " · Violet Purple" the card appends to its
         name would just repeat the select — print the bare product name and let the control
         carry the colour, exactly as the model select does. */
      name: (col.options.length > 1 && card.dataset.baseName) ? card.dataset.baseName : card.dataset.name,
      img: img ? (img.currentSrc || img.src) : '',
      device: dev.label,
      deviceOptions: dev.options,
      deviceKind: dev.kind,
      color: col.label,
      colorOptions: col.options
    };
  }

  /* Two filter dimensions: model tabs (block id) × category chips (data-cat).
     Chips with nothing under the active model dim out; if the active category
     empties after a model switch it falls back to All. */
  var currentModel = 'all';
  var catsEl = document.getElementById('tss-cats');
  /* There is no "All" chip any more, so the starting category is whichever chip
     ships with `.on` from Liquid — swapping the default stays a markup decision.
     'all' survives only as the no-filter sentinel inCat() still understands, used
     if the row is ever empty. */
  var firstChip = catsEl ? catsEl.querySelector('[data-cat].on') || catsEl.querySelector('[data-cat]') : null;
  var currentCat = firstChip ? firstChip.dataset.cat : 'all';

  /* Chips proven to have NOTHING in the whole catalogue (not merely nothing under the
     current model) — a lazy fetch that came back empty, or a category ops emptied out.
     Those are gone for good; per-model hiding below is two-way and must not resurrect
     them on the next model switch. */
  var chipRetired = {};
  function retireChip(ch){
    if(!ch) return;
    chipRetired[ch.dataset.cat] = true;
    ch.hidden = true;
    ch.disabled = true;
  }

  /* Where to land when the active category empties under a new model tab. Used to
     be a hardcoded 'all'; without that chip it has to be a real, usable one. */
  var catFallingBack = false;
  function fallbackCat(){
    if(!catsEl) return 'all';
    var pick = null;
    catsEl.querySelectorAll('[data-cat]').forEach(function(ch){
      if(pick || ch.hidden || ch.disabled) return;
      pick = ch.dataset.cat;
    });
    return pick || 'all';
  }

  /* Order the ranked (Best sellers) row runs its categories in: glass, then cases,
     then the rest. Pure sales order ranks against the WHOLE store, which is carried
     by the iPhone 17 SKUs — so on a thinner tab the only local product that charted
     was a universal lanyard and the row opened on it. Screen protectors are what
     this page exists to sell and what the shopper came for, so they lead, cases
     follow, and the sales ranking decides the order INSIDE each group. */
  var BEST_CAT_ORDER = ['screen', 'case', 'lens', 'accessories', 'charging'];
  function catRank(card){
    var i = BEST_CAT_ORDER.indexOf(card.dataset.cat || 'accessories');
    return i < 0 ? BEST_CAT_ORDER.length : i;
  }

  /* How many genuinely top-selling cards a model needs before "Best sellers" can
     stand on real sales data — a desktop page (4) plus a peek. Under that the chip
     showed a one- or two-card row, which reads as broken rather than curated, so the
     view widens to that model's whole lineup instead. Recomputed per model. */
  var BEST_MIN = 6;
  var bestFallback = false;

  /* Categories that only make sense for a named device. A cross-catalogue ('*') card
     in one of these has to prove it fits the selected phone; an accessory or charger
     fits everything and needs no proof. */
  var DEVICE_BOUND = { screen: 1, lens: 1, case: 1 };

  /* Every device a card can actually be bought for, or null when it is universal.
     Three catalogue shapes, same as deviceInfo(): a Device option (union of the
     swatch vmaps — a colour need not exist for every device), a protector family of
     sibling products, or a single-model SKU. */
  function cardDevices(card){
    var sws = card.querySelectorAll('[data-sw][data-vmap]');
    if(sws.length){
      var seen = {}, out = [];
      Array.prototype.forEach.call(sws, function(s){
        try{
          Object.keys(JSON.parse(s.getAttribute('data-vmap'))).forEach(function(k){
            if(!seen[k]){ seen[k] = 1; out.push(k); }
          });
        }catch(err){}
      });
      if(out.length) return out;
    }
    var fam = cardFamily(card);
    if(fam) return fam.map(function(f){ return f.d; });
    if(card.dataset.device) return [card.dataset.device];
    if(card.dataset.availDevices) return card.dataset.availDevices.split('||');
    return null;
  }

  /* `best` is not a category — it cuts across them (a SunView glass is both "screen"
     and a best seller), so the card carries a separate data-best flag instead of a
     second data-cat value. Every place that used to compare data-cat goes through
     here so the three of them can't drift apart. */
  function inCat(card, cat){
    if(cat === 'all') return true;
    if(cat === 'best') return bestFallback || card.dataset.best === '1';
    return (card.dataset.cat || 'accessories') === cat;
  }

  function applyModel(btn){
    if(!btn || !btn.dataset.model) return;
    currentModel = btn.dataset.model;
    /* data-label is the authoritative device name (the element's text can carry the
       check-mark markup); it must match the product's Device option value verbatim. */
    currentDevice = currentModel === 'all' ? '' : ((btn.dataset.label || btn.textContent) || '').trim();
    applyFilters();
  }
  function applyFilters(){
    if(!grid) return;
    var counts = { all: 0 };
    var visible = 0;
    /* TWO passes, because `inCat(card, 'best')` needs a decision — bestFallback —
       that can only be made once every card has been tested against the model. */
    var ids = Object.keys(cards);
    var modelShow = {};
    var ranked = 0;
    ids.forEach(function(id){
      var c = cards[id];
      var cModel = c.dataset.model || '';
      var mShow;
      if(currentModel === 'all'){
        mShow = true;
      } else if(cModel === '*'){
        /* '*' = not tied to any Model tab — a card fetched by a cross-cutting chip,
           i.e. straight off /collections/all. It used to show under EVERY model, and
           the store-wide sales list is not a phone-specific one: the #1 seller is a
           Nintendo Switch 2 glass and an iPad case charts at #11, so both sat in the
           Best sellers row of every iPhone tab while that tab's own products, which
           don't chart store-wide, did not. A '*' card in a device-bound category now
           has to name the selected device; universal accessories and chargers still
           show everywhere. retargetCard still points the survivors at the shopper's
           device via data-family / data-vmap. */
        var devs = cardDevices(c);
        if(devs){ mShow = !!currentDevice && devs.indexOf(currentDevice) > -1; }
        else { mShow = !DEVICE_BOUND[c.dataset.cat || 'accessories']; }
      } else {
        mShow = cModel.split(/\s+/).indexOf(currentModel) > -1;
      }
      /* One product covering several models can be sold out for just one of them,
         which data-model (a Theme Editor pick) knows nothing about. The card then
         carries data-avail-devices — the Device values still buyable — and drops
         off the tabs missing from it. Only partially sold-out products emit the
         attribute, so a fully-stocked card behaves exactly as before. */
      if(mShow && currentDevice && c.dataset.availDevices){
        mShow = c.dataset.availDevices.split('||').indexOf(currentDevice) > -1;
      }
      modelShow[id] = mShow;
      if(mShow){
        counts.all++;
        var k = c.dataset.cat || 'accessories';
        counts[k] = (counts[k] || 0) + 1;
        /* Counted on top of its own category, not instead of it. */
        if(c.dataset.best === '1'){ ranked++; }
      }
    });
    /* Too few charting products under this model to fill a row — show the whole
       lineup rather than a near-empty one. applyOrder() has already laid the track
       out glass-first, so the widened row still opens on a screen protector. */
    bestFallback = ranked < BEST_MIN;
    counts.best = bestFallback ? counts.all : ranked;

    ids.forEach(function(id){
      var c = cards[id];
      var show = modelShow[id] && inCat(c, currentCat);
      c.hidden = !show;
      if(show){ retargetCard(c); visible++; }
    });
    if(catsEl){
      /* Active category emptied under this model tab — move to a usable chip.
         `catFallingBack` guards the recursion: setCat() re-enters applyFilters, and
         if the fallback is empty too we'd bounce forever. One hop, then stop and let
         the empty-state message do its job. */
      if(currentCat !== 'all' && !counts[currentCat] && !catFallingBack){
        var next = fallbackCat();
        if(next !== currentCat){
          catFallingBack = true;
          setCat(next);
          catFallingBack = false;
          return;
        }
      }
      catsEl.querySelectorAll('[data-cat]').forEach(function(ch){
        var cat = ch.dataset.cat;
        var n = cat === 'all' ? counts.all : (counts[cat] || 0);
        /* A lazy chip has nothing to count until it has been fetched — hiding or
           disabling it would make it unclickable and it could never load. */
        var pending = isLazyPending(cat);
        var empty = !n && !pending;
        /* An empty category is REMOVED for this model, not dimmed: a greyed-out
           "Lens protectors" chip on a phone we sell no lens protector for still reads
           as a promise the page can't keep. Two-way — the next model may well have
           stock in that category — except for chips retireChip() proved empty
           catalogue-wide. The ACTIVE chip always stays visible: when a model has
           nothing at all every chip is empty, and hiding the entire row would leave
           the builder headless above the "nothing here yet" message. */
        ch.hidden = !!chipRetired[cat] || (empty && cat !== currentCat);
        ch.classList.toggle('is-off', empty);
        ch.disabled = empty;
      });
    }
    var none = document.getElementById('tss-none');
    if(none){ none.hidden = visible > 0; }
    if(track){ track.scrollLeft = 0; }
    paintCarousel();
  }
  /* A ranked chip re-sorts the grid by BEST_CAT_ORDER first (glass → cases → …) and
     by the sales order the endpoint returned within each group. It used to sort by
     sales alone, on the theory that mixing categories back in stopped "Best sellers"
     and "Screen protectors" reading as the same screen. They still don't: this row
     runs glass into cases and accessories, the other shows only glass. What sales
     alone actually cost was the top of the row — the ranking is store-wide, so a
     model whose own SKUs don't chart opened on whatever universal accessory did.
     The order is the only thing that changes — no position is ever printed on a
     card, so no view can claim a rank a product doesn't hold. */
  /* Which category leads the ranked view, if any. Merchandising override on top of
     the sales order — set in the Theme Editor, not hardcoded. */
  var leadCat = (catsEl && catsEl.dataset.leadCat) || '';

  /* Real sales data decides membership. The endpoint returns the catalogue in
     best-selling order, so being in that list IS being a best seller — this
     overwrites the pre-fetch seed the Liquid guessed from the editorial badge.
     The position itself is not stamped anywhere: the order is expressed by the DOM
     order applyOrder() produces, and nothing prints a rank number. */
  function reconcileBest(cat){
    var order = chipOrder[cat];
    if(!order) return;
    var inList = {};
    order.forEach(function(id){ inList[id] = true; });
    Object.keys(cards).forEach(function(id){
      var c = cards[id];
      if(inList[id]) c.dataset.best = '1';
      else if(c.dataset.best === '1') delete c.dataset.best;
    });
  }

  function applyOrder(cat){
    if(!track) return;
    var order = chipOrder[cat];
    if(!order || !order.length) return;
    var rank = {};
    order.forEach(function(id, i){ rank[id] = i; });

    /* Sorts EVERY card in the track, not just the ranked run: on a model with too
       few charting products the row falls back to the whole lineup (bestFallback),
       so an unranked card needs a defined slot too. The order is model-independent
       — filtering only flips [hidden] — so this survives every model switch and
       does not need re-running when the picker changes. */
    var all = Array.prototype.slice.call(track.querySelectorAll('.card[data-id]'));

    /* ONE card from the lead category may still open the row — the best-selling one,
       since `order` is already sales-sorted. Optional merchandising override that now
       sits IN FRONT of the category grouping below; left unset the row simply opens
       on the top-selling screen protector. Nothing prints a position, so this can't
       make the page claim a wrong rank. */
    var lead = null;
    if(leadCat){
      for(var i = 0; i < order.length && !lead; i++){
        var lc = cards[order[i]];
        if(lc && lc.dataset.cat === leadCat){ lead = lc; }
      }
    }

    all.sort(function(a, b){
      if(a === b) return 0;
      if(a === lead) return -1;
      if(b === lead) return 1;
      var ca = catRank(a), cb = catRank(b);
      if(ca !== cb) return ca - cb;
      /* Unranked cards share one slot at the back of their category and keep their
         original relative order — Array#sort is stable. A finite sentinel, not
         Infinity: Infinity - Infinity is NaN and would corrupt the comparator. */
      var ra = rank[a.dataset.id] === undefined ? 1e9 : rank[a.dataset.id];
      var rb = rank[b.dataset.id] === undefined ? 1e9 : rank[b.dataset.id];
      return ra - rb;
    });

    var frag = document.createDocumentFragment();
    all.forEach(function(c){ frag.appendChild(c); });
    track.appendChild(frag);
  }

  function setCat(cat){
    currentCat = cat;
    if(catsEl){
      catsEl.querySelectorAll('[data-cat]').forEach(function(ch){ ch.classList.toggle('on', ch.dataset.cat === cat); });
    }
    applyOrder(cat);
    applyFilters();
  }

  /* ---- Lazy chips (Section Rendering API) ------------------------------------
     Some chips aren't a filter over the cards already in the page — "Best sellers"
     spans the whole catalogue, not just the products hand-picked into the Model
     tabs. Rather than ship those extra cards with every page load, fetch them the
     first time the chip is used.

     The request goes to a collection URL, not this page: `section_id` may only
     name a section of the requested template, and this builder sits on a page
     template, so asking for itself would give no `collection` in scope. The
     endpoint is a .liquid template, which is why the id is a plain file name
     rather than an unstable `template--<id>__<key>`.

     Fetched once per chip and kept — re-clicking is instant and offline-safe. A
     failure leaves the chip working as a plain filter over whatever is already
     rendered, so the builder never ends up worse than before the fetch. */
  var LAZY_CHIPS = {
    best: '/collections/all?view=ss-cards&section_id=torras-ss-cards&sort_by=best-selling'
  };
  var chipLoaded = {};
  var chipLoading = {};
  /* Sales rank per lazy chip: the endpoint is sorted best-selling first, so the
     order it returns is the only sales signal on the storefront. Kept even when a
     card was already in the page (the usual case — the Model tabs are curated from
     the same catalogue), because the ORDER is the part we can't get locally. */
  var chipOrder = {};
  function isLazyPending(cat){ return !!(LAZY_CHIPS && LAZY_CHIPS[cat] && !chipLoaded[cat]); }

  function absorbCards(html, cat){
    var host = document.createElement('div');
    host.innerHTML = html;
    var incoming = host.querySelectorAll('.card[data-id]');
    if(!incoming.length) return 0;
    if(cat){ chipOrder[cat] = Array.prototype.map.call(incoming, function(n){ return n.dataset.id; }); }
    var added = 0;
    incoming.forEach(function(node){
      /* A product can be both a Model-tab pick and a best seller. Keep the card
         already in the DOM — it carries the real data-model list, and it may be
         the one the shopper has already added to the bundle. */
      if(cards[node.dataset.id]) return;
      node.hidden = true;
      track.appendChild(node);
      added++;
    });
    if(added){
      indexCards();
      /* Okendo hydrates star ratings by scanning for its placeholders; injected
         ones are invisible to the initial pass. No-op when the app isn't loaded. */
      try{
        if(window.okeWidgetApi && typeof window.okeWidgetApi.initWidget === 'function'){
          track.querySelectorAll('[data-oke-star-rating]').forEach(function(el){
            window.okeWidgetApi.initWidget(el);
          });
        }
      }catch(err){}
    }
    return added;
  }

  function loadChip(cat, done){
    if(!LAZY_CHIPS[cat] || chipLoaded[cat] || chipLoading[cat] || !track){ done(); return; }
    chipLoading[cat] = true;
    if(grid){ grid.setAttribute('data-loading', '1'); }
    fetch(LAZY_CHIPS[cat], { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function(html){
        absorbCards(html, cat);
        reconcileBest(cat);
        chipLoaded[cat] = true;
      })
      .catch(function(){
        /* Don't retry on every click — one failed round trip per chip is enough.
           The chip still filters the cards already on the page. */
        chipLoaded[cat] = true;
      })
      .then(function(){
        chipLoading[cat] = false;
        if(grid){ grid.removeAttribute('data-loading'); }
        /* Repaint the picked state: absorbCards may have added cards, and the
           green tick lives on the card, not in `selected`. */
        try{ render(); }catch(err){}
        done();
      });
  }

  /* The chip the page OPENS on is lazy (Best sellers), and its whole point is the
     sales ranking, which only the endpoint knows. Warm it on idle: off the critical
     path, so the HTML stays small and first paint is untouched, but the ranking is
     usually in place before anyone has scrolled to the grid. Chips the shopper has
     not opened still wait for a real click. */
  if(isLazyPending(currentCat)){
    var warm = function(){ loadChip(currentCat, function(){ applyOrder(currentCat); applyFilters(); }); };
    if(window.requestIdleCallback){ window.requestIdleCallback(warm, { timeout: 2000 }); }
    else { setTimeout(warm, 600); }
  }

  if(catsEl){
    /* Hide chips whose category has no products at all (e.g. ops removed every charger,
       or nothing in the catalogue currently earns the best-seller flag). */
    var catTotals = {};
    Object.keys(cards).forEach(function(id){
      var c = cards[id];
      var k = c.dataset.cat || 'accessories';
      catTotals[k] = (catTotals[k] || 0) + 1;
      if(c.dataset.best === '1'){ catTotals.best = (catTotals.best || 0) + 1; }
    });
    catsEl.querySelectorAll('[data-cat]').forEach(function(ch){
      /* A lazy chip's products aren't in the page yet, so catTotals says zero for it.
         Leave it visible — it hides itself after the fetch if nothing came back. */
      if(ch.dataset.cat !== 'all' && !catTotals[ch.dataset.cat] && !isLazyPending(ch.dataset.cat)){ retireChip(ch); }
    });
    catsEl.addEventListener('click', function(e){
      var ch = e.target.closest('[data-cat]');
      if(!ch || ch.disabled) return;
      var cat = ch.dataset.cat;
      try{ ch.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }catch(err){}
      /* Fetch-then-filter. loadChip calls back synchronously for chips that need no
         fetch, so the common path stays as immediate as it was before. */
      loadChip(cat, function(){
        setCat(cat);
        /* Nothing came back and nothing local matches: retire the chip rather than
           leave a dead control. applyFilters() has already moved on. */
        if(!isLazyPending(cat) && currentCat !== cat){ retireChip(ch); }
      });
    });
  }

  /* Builder carousel. The card grid is a snap-scrolled track; pages are measured in
     scrollport widths, so a fractional cards-per-view (the mobile peek) still yields
     honest dots. Filtering only flips [hidden] on cards, so every page count has to be
     re-measured after applyFilters, on resize, and while the shopper drag-scrolls. */
  var track = grid ? grid.querySelector('[data-tss-cards]') : null;
  var navEl = grid ? grid.querySelector('[data-bld-nav]') : null;
  var dotsEl = navEl ? navEl.querySelector('[data-bld-dots]') : null;
  var prevBtn = navEl ? navEl.querySelector('[data-bld-prev]') : null;
  var nextBtn = navEl ? navEl.querySelector('[data-bld-next]') : null;

  /* Page in CARD steps, not scrollport widths: every page boundary swallows one gap,
     so paging by clientWidth drifts a gap per page and invents a sliver-wide last page.
     step = distance between two cards, perView = how many fit, pages = ceil(cards/perView). */
  function metrics(){
    if(!track) return null;
    var vis = Array.prototype.filter.call(track.querySelectorAll('.card'), function(c){ return !c.hidden; });
    if(!vis.length) return null;
    var step = vis.length > 1 ? (vis[1].offsetLeft - vis[0].offsetLeft) : vis[0].offsetWidth;
    if(!step) return null;
    var perView = Math.max(1, Math.round(track.clientWidth / step));
    return { step: step, perView: perView, pages: Math.max(1, Math.ceil(vis.length / perView)) };
  }
  function maxScroll(){ return Math.max(0, track.scrollWidth - track.clientWidth); }
  function pageIndex(m){
    if(!m) return 0;
    if(track.scrollLeft >= maxScroll() - 2) return m.pages - 1;
    return Math.max(0, Math.min(m.pages - 1, Math.round(track.scrollLeft / (m.perView * m.step))));
  }
  function goPage(i){
    var m = metrics();
    if(!m) return;
    i = Math.max(0, Math.min(m.pages - 1, i));
    track.scrollTo({ left: i >= m.pages - 1 ? maxScroll() : i * m.perView * m.step, behavior: 'smooth' });
  }
  function paintCarousel(){
    if(!track || !navEl) return;
    /* 2px slack — sub-pixel column math must not fake an extra page. */
    navEl.hidden = maxScroll() <= 2;
    if(navEl.hidden) return;
    var m = metrics();
    if(!m) return;
    var pages = m.pages;
    if(dotsEl && dotsEl.childElementCount !== pages){
      dotsEl.innerHTML = '';
      for(var i = 0; i < pages; i++){
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'bld-dot';
        d.setAttribute('data-page', i);
        d.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + pages);
        dotsEl.appendChild(d);
      }
    }
    var idx = pageIndex(m);
    if(dotsEl){
      Array.prototype.forEach.call(dotsEl.children, function(d, i){
        if(i === idx){ d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }
    if(prevBtn){ prevBtn.disabled = idx <= 0; }
    if(nextBtn){ nextBtn.disabled = idx >= pages - 1; }
  }
  if(track && navEl){
    if(prevBtn){ prevBtn.addEventListener('click', function(){ goPage(pageIndex(metrics()) - 1); }); }
    if(nextBtn){ nextBtn.addEventListener('click', function(){ goPage(pageIndex(metrics()) + 1); }); }
    if(dotsEl){
      dotsEl.addEventListener('click', function(e){
        var d = e.target.closest('[data-page]');
        if(d){ goPage(parseInt(d.getAttribute('data-page'), 10)); }
      });
    }
    var cRaf = 0;
    track.addEventListener('scroll', function(){
      if(cRaf) return;
      cRaf = requestAnimationFrame(function(){ cRaf = 0; paintCarousel(); });
    }, { passive: true });
    window.addEventListener('resize', paintCarousel);
    paintCarousel();
  }

  function selectSwatch(sw){
    var card = sw.closest('.card');
    card.querySelectorAll('[data-sw]').forEach(function(x){ x.classList.toggle('on', x === sw); });
    card.dataset.variant = resolveVariant(sw);
    card.dataset.price = sw.dataset.price;
    card.dataset.name = (card.dataset.baseName || '') + ' · ' + sw.dataset.label;
    var img = card.querySelector('[data-card-img]'); if(img){ img.src = sw.dataset.image; }
    var now = card.querySelector('[data-card-now]'); if(now){ now.textContent = sw.dataset.now; }
    var was = card.querySelector('[data-card-was]');
    if(was){ if(sw.dataset.was){ was.textContent = sw.dataset.was; was.hidden = false; } else { was.hidden = true; } }
    var sv = card.querySelector('[data-card-save]');
    if(sv){ if(sw.dataset.save){ sv.textContent = sw.dataset.save; sv.hidden = false; } else { sv.hidden = true; } }
    if(selected.indexOf(card.dataset.id) > -1){ snapshot(card); render(); }
  }

  var fmt = function(n){ return '$' + n.toFixed(2); };
  /* Bundle builder = add to a PACKAGE, not a cart — use a package/box glyph. */
  var CARD_CART = '<svg viewBox="0 0 24 24"><path d="M16.5 9.4 7.5 4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>';
  var CARD_CHK = '<svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>';
  function currentTier(count){
    for(var i=0;i<TIERS.length;i++){ if(count>=TIERS[i].min) return TIERS[i]; }
    return null;
  }

  var sumItems = document.getElementById('tss-sum-items');
  var sumEmpty = document.getElementById('tss-sum-empty');
  var progBar = document.getElementById('tss-prog-bar');
  var dockBar = document.getElementById('tss-dock-bar');

  function render(){
    var count = selected.length;
    var subtotal = selected.reduce(function(s,id){ return s + (selectedMeta[id] ? selectedMeta[id].price : 0); }, 0);
    var tier = currentTier(count);
    var pct = tier ? tier.pct : 0;
    var discount = subtotal * pct;
    var total = subtotal - discount;

    // card button states
    Object.keys(cards).forEach(function(id){
      var c = cards[id], picked = selected.indexOf(id) > -1;
      c.classList.toggle('pick', picked);
      var btn = c.querySelector('[data-add]');
      btn.innerHTML = picked ? CARD_CHK : CARD_CART;
      btn.setAttribute('aria-pressed', picked ? 'true' : 'false');
    });

    // summary list
    sumItems.querySelectorAll('.sum-item').forEach(function(n){ n.remove(); });
    if(count === 0){
      sumEmpty.hidden = false;
    } else {
      sumEmpty.hidden = true;
      selected.forEach(function(id){
        var meta = selectedMeta[id];
        if(!meta) return;
        var row = document.createElement('div');
        row.className = 'sum-item';
        var devHtml = '';
        if(meta.deviceOptions && meta.deviceOptions.length > 1){
          devHtml = '<label class="dev"><span class="vh">Model</span><select class="dev-sel" data-dev="'+esc(id)+'">' +
            meta.deviceOptions.map(function(d){
              return '<option value="'+esc(d)+'"'+(d===meta.device?' selected':'')+'>'+esc(d)+'</option>';
            }).join('') +
            '</select></label>';
        } else if(meta.device){
          devHtml = '<div class="dev dev--static">'+esc(meta.device)+'</div>';
        }
        /* Colour is committed at add-time too, so it needs its own way back — without this
           the only way to recolour a line was to find its card again and click a swatch. */
        var colHtml = '';
        if(meta.colorOptions && meta.colorOptions.length > 1){
          colHtml = '<label class="dev"><span class="vh">Color</span><select class="dev-sel" data-col="'+esc(id)+'">' +
            meta.colorOptions.map(function(c){
              return '<option value="'+esc(c)+'"'+(c===meta.color?' selected':'')+'>'+esc(c)+'</option>';
            }).join('') +
            '</select></label>';
        }
        row.innerHTML =
          '<div class="thumb"><img src="'+esc(meta.img)+'" alt=""></div>' +
          '<div class="sum-item__body"><div class="nm">'+esc(meta.name)+'</div>' + devHtml + colHtml +
          '<div class="pr">'+fmt(meta.price)+'</div></div>' +
          '<button class="rm" data-rm="'+esc(id)+'">Remove</button>';
        sumItems.appendChild(row);
      });
    }

    // progress: 0 items→0, 1→33%, 2→66%, 3+→100%
    var pctBar = Math.min(count,3) / 3 * 100;
    progBar.style.width = pctBar + '%';
    if(dockBar) dockBar.style.width = pctBar + '%';

    // marks highlight
    document.getElementById('tss-mk1').classList.toggle('hit', count>=1);
    document.getElementById('tss-mk2').classList.toggle('hit', count>=2);
    document.getElementById('tss-mk3').classList.toggle('hit', count>=3);

    // headline + next-step copy
    var headline = document.getElementById('tss-sum-headline');
    var next = document.getElementById('tss-sum-next');
    if(count >= 3){
      headline.innerHTML = 'You saved <span class="scr">15%</span>';
      next.textContent = 'Top tier unlocked — maximum bundle savings.';
    } else if(count === 2){
      headline.innerHTML = 'You saved <span class="scr">12%</span>';
      next.textContent = 'Add 1 more item to reach −15%.';
    } else if(count === 1){
      headline.innerHTML = 'You saved <span class="scr">10%</span>';
      next.textContent = 'Add 1 more item to step up to −12%.';
    } else {
      headline.innerHTML = 'Save up to <span class="scr">15%</span>';
      next.textContent = 'Every item saves — add one to start at −10%.';
    }

    // totals
    var discRow = document.getElementById('tss-disc-row');
    if(discount > 0){
      discRow.hidden = false;
      document.getElementById('tss-disc-label').textContent = 'Bundle discount (' + Math.round(pct*100) + '%)';
      document.getElementById('tss-disc-amt').textContent = '−' + fmt(discount);
    } else {
      discRow.hidden = true;
    }
    document.getElementById('tss-items-label').textContent = count + (count===1?' item':' items');
    document.getElementById('tss-total').textContent = 'Total: ' + fmt(total);

    var checkout = document.getElementById('tss-checkout');
    checkout.disabled = count === 0;
    checkout.textContent = count >= 1 ? ('Add bundle to cart · ' + fmt(total)) : 'Add bundle to cart';

    /* Mobile dock — on small screens this IS the summary; the receipt only appears when
       the shopper opens the sheet, so the bar has to carry count, tier and total itself. */
    var dockB = document.getElementById('tss-dock-b'), dockS = document.getElementById('tss-dock-s');
    dockB.textContent = count === 0 ? 'Your bundle is empty'
                      : count + (count===1?' item':' items') + ' · ' + fmt(total);
    dockS.textContent = count>=3 ? 'Top tier −15% · you saved '+fmt(discount) :
                        count===2 ? '−12% applied · add 1 for −15%' :
                        count===1 ? '−10% applied · add 1 for −12%' :
                        'Every item saves — start at −10%';
    var sheetCount = document.getElementById('tss-sheet-count');
    if(sheetCount){ sheetCount.textContent = count + (count===1?' item':' items'); }
    var dockCta = document.getElementById('tss-dock-cta');
    if(dockCta){
      /* Empty bundle = nothing to add, so grey it out. The dock only rides along with the
         builder now, so a "Build bundle" jump-link here would point at the screen you are
         already looking at. */
      dockCta.textContent = count === 0 ? 'Add bundle to cart' : 'Add bundle to cart · ' + fmt(total);
      dockCta.disabled = count === 0;
    }
    /* Both count badges: the dock's (only alive over the builder) and the sticky sub-nav's
       (the cue that survives scrolling away). */
    [document.getElementById('tss-dock-badge'), document.getElementById('tss-nav-badge')]
      .forEach(function(bdg){
        if(!bdg) return;
        bdg.textContent = count;
        bdg.hidden = count === 0;
      });
    /* Nothing left to review — don't strand the sheet open over an empty ledger. */
    if(count === 0){ closeSheet(); }
  }

  /* ---------- bundle sheet (mobile): the receipt slides up out of the dock ---------- */
  var tssRoot = document.getElementById('tss-dock') ? document.getElementById('tss-dock').closest('.t-ss') : null;
  var scrim = tssRoot ? tssRoot.querySelector('.dock-scrim') : null;
  var dockToggle = tssRoot ? tssRoot.querySelector('[data-dock-toggle]') : null;

  function sheetIsOpen(){ return !!(tssRoot && tssRoot.classList.contains('sheet-open')); }
  function setMoreLabel(txt){
    var l = tssRoot && tssRoot.querySelector('[data-dock-more-label]');
    if(l) l.textContent = txt;
  }
  function openSheet(){
    if(!tssRoot || sheetIsOpen()) return;
    tssRoot.classList.add('sheet-open');
    if(scrim) scrim.hidden = false;
    if(dockToggle) dockToggle.setAttribute('aria-expanded', 'true');
    setMoreLabel('Hide receipt');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeSheet(){
    if(!tssRoot || !sheetIsOpen()) return;
    tssRoot.classList.remove('sheet-open');
    if(dockToggle) dockToggle.setAttribute('aria-expanded', 'false');
    setMoreLabel('View receipt');
    document.documentElement.style.overflow = '';
    /* Keep the scrim in the DOM through the slide-out so it fades instead of vanishing. */
    if(scrim){ setTimeout(function(){ if(!sheetIsOpen()) scrim.hidden = true; }, 320); }
  }
  if(tssRoot){
    tssRoot.addEventListener('click', function(e){
      if(e.target.closest('[data-dock-close]')){ closeSheet(); return; }
      if(e.target.closest('[data-dock-toggle]')){ sheetIsOpen() ? closeSheet() : openSheet(); return; }
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeSheet(); });
    var dockCtaEl = document.getElementById('tss-dock-cta');
    if(dockCtaEl){
      dockCtaEl.addEventListener('click', function(){
        if(dockCtaEl.disabled || selected.length === 0) return;
        /* Same commit path as the sheet's own button — one cart implementation. */
        var co = document.getElementById('tss-checkout');
        if(co) co.click();
      });
    }
  }

  function toggle(id){
    var i = selected.indexOf(id);
    if(i > -1){ selected.splice(i,1); delete selectedMeta[id]; }
    else { selected.push(id); snapshot(cards[id]); }
    render();
  }

  grid.addEventListener('click', function(e){
    var sw = e.target.closest('[data-sw]');
    if(sw){ selectSwatch(sw); return; }
    var add = e.target.closest('[data-add]');
    if(add){ toggle(add.closest('.card').dataset.id); return; }
    var rm = e.target.closest('[data-rm]');
    if(rm){ toggle(rm.dataset.rm); }
  });
  /* Change the model straight from the receipt line: re-resolve the variant through the
     card's own vmap so price and cart id stay in lockstep with the label. */
  grid.addEventListener('change', function(e){
    /* Change the colour straight from the receipt line. Resolves through THIS line's device
       (not the active model) so a case whose model was switched on the receipt keeps that
       model when recoloured, and keeps the card in lockstep so grid and receipt agree. */
    var colSel = e.target.closest('[data-col]');
    if(colSel){
      var cid = colSel.getAttribute('data-col');
      var cmeta = selectedMeta[cid];
      var ccard = cards[cid];
      if(!cmeta || !ccard) return;
      var pick = null;
      ccard.querySelectorAll('[data-sw]').forEach(function(x){ if(x.dataset.label === colSel.value){ pick = x; } });
      if(!pick) return;
      var vid = resolveVariant(pick, cmeta.device);
      cmeta.variant = String(vid);
      cmeta.price = parseFloat(pick.dataset.price);
      cmeta.color = pick.dataset.label;
      if(pick.dataset.image){ cmeta.img = pick.dataset.image; }
      ccard.querySelectorAll('[data-sw]').forEach(function(x){ x.classList.toggle('on', x === pick); });
      ccard.dataset.variant = String(vid);
      ccard.dataset.price = pick.dataset.price;
      ccard.dataset.name = (ccard.dataset.baseName || '') + ' · ' + pick.dataset.label;
      var cImg = ccard.querySelector('[data-card-img]'); if(cImg && pick.dataset.image){ cImg.src = pick.dataset.image; }
      var cNow = ccard.querySelector('[data-card-now]'); if(cNow){ cNow.textContent = pick.dataset.now; }
      var cWas = ccard.querySelector('[data-card-was]');
      if(cWas){ if(pick.dataset.was){ cWas.textContent = pick.dataset.was; cWas.hidden = false; } else { cWas.hidden = true; } }
      var cSave = ccard.querySelector('[data-card-save]');
      if(cSave){ if(pick.dataset.save){ cSave.textContent = pick.dataset.save; cSave.hidden = false; } else { cSave.hidden = true; } }
      render();
      return;
    }
    var sel = e.target.closest('[data-dev]');
    if(!sel) return;
    var id = sel.getAttribute('data-dev');
    var meta = selectedMeta[id];
    var card = cards[id];
    if(!meta || !card) return;
    if(meta.deviceKind === 'family'){
      /* Protectors: the sibling is a different PRODUCT, so swap the whole snapshot —
         variant, price, title and thumb — but leave the card alone; it still represents
         the model it was picked under. */
      var fam = cardFamily(card) || [];
      var pick = fam.filter(function(f){ return f.d === sel.value; })[0];
      if(!pick) return;
      meta.variant = String(pick.v);
      meta.price = parseFloat(pick.p);
      meta.name = pick.n;
      meta.img = pick.i || meta.img;
      meta.device = pick.d;
    } else {
      /* Cases: same product, another Device variant — keep the card in lockstep. */
      var on = card.querySelector('[data-sw].on') || card.querySelector('[data-sw]');
      if(!on || !on.getAttribute('data-vmap')) return;
      try{
        var map = JSON.parse(on.getAttribute('data-vmap'));
        var vid = map[sel.value];
        if(!vid) return;
        meta.variant = String(vid);
        meta.device = sel.value;
        card.dataset.variant = String(vid);
      }catch(err){ return; }
    }
    /* The colour list is scoped to the device (a colour need not exist for every
       model), so re-derive it here or the line keeps offering colours the new model
       can't be bought in. The device options come from the live swatch's own map, so
       the current colour always survives the switch — but re-seat it if it ever
       doesn't, rather than leaving the select pointing at nothing. */
    var col2 = colorInfo(card, meta.device);
    meta.colorOptions = col2.options;
    if(col2.options.length && col2.options.indexOf(meta.color) < 0){ meta.color = col2.label; }
    render();
  });
  /* Swatch hover = live variant-image preview (revert to the selected one on leave). */
  grid.addEventListener('mouseover', function(e){
    var sw = e.target.closest('[data-sw]');
    if(!sw) return;
    var img = sw.closest('.card').querySelector('[data-card-img]');
    if(img){ img.src = sw.dataset.image; }
  });
  grid.addEventListener('mouseout', function(e){
    var sw = e.target.closest('[data-sw]');
    if(!sw) return;
    var card = sw.closest('.card');
    var on = card.querySelector('[data-sw].on') || sw;
    var img = card.querySelector('[data-card-img]');
    if(img){ img.src = on.dataset.image; }
  });

  /* Open Horizon's cart drawer instead of navigating to /cart. The whole cart UI (drawer
     contents, header cart icon, totals) re-renders off a single `cart:update` event — with
     no `sections` payload each component simply re-fetches its own section, which is the
     documented fallback in component-cart-items. The drawer only opens ITSELF on that event
     when it carries [auto-open], so open it explicitly when it doesn't (and never twice).
     If the shop has no drawer at all, fall back to the old redirect. */
  function openCartDrawer(cart){
    var drawer = document.querySelector('cart-drawer-component');
    if(!drawer || typeof drawer.showDialog !== 'function'){ window.location.href = '/cart'; return; }
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || undefined,
        sourceId: 'tss-checkout',
        data: { source: 'summer-bundle-builder' }
      }
    }));
    if(!drawer.hasAttribute('auto-open')){ drawer.showDialog(); }
  }

  /* Real add-to-cart: POST every snapshotted variant to /cart/add.js, then pop the drawer. */
  var checkoutBtn = document.getElementById('tss-checkout');
  if(checkoutBtn){
    checkoutBtn.addEventListener('click', function(){
      if(checkoutBtn.disabled || !selected.length) return;
      var items = selected.map(function(id){
        return selectedMeta[id] ? { id: parseInt(selectedMeta[id].variant, 10), quantity: 1 } : null;
      }).filter(function(it){ return it && it.id; });
      if(!items.length) return;
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Adding to cart…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r){
        if(!r.ok){ throw new Error('cart add failed'); }
        /* /cart/add.js returns the added lines, not the cart — the drawer's a11y count
           announcement and the header icon both want the real cart object. */
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(cr){ return cr.ok ? cr.json() : null; })
          .catch(function(){ return null; });
      }).then(function(cart){
        /* We no longer navigate away, so the builder has to be handed back in a clean
           state: leaving the picks selected would let a second click silently add the
           same bundle again. Clearing + render() also restores the button's own label. */
        selected.length = 0;
        Object.keys(selectedMeta).forEach(function(k){ delete selectedMeta[k]; });
        checkoutBtn.disabled = false;
        render();
        openCartDrawer(cart);
      }).catch(function(){
        checkoutBtn.textContent = 'Could not add — try again';
        checkoutBtn.disabled = false;
        setTimeout(function(){ render(); }, 2500);
      });
    });
  }

  /* ---------- 5. FAQ accordion ---------- */
  document.querySelectorAll('.faq-item .faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.closest('.faq-item');
      var a = item.querySelector('.faq-a');
      var open = item.classList.toggle('open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  });

  /* ---------- 6. mobile dock: small screens only, and only over the bundle builder ----------
     The bar is the builder's summary, so it has no business floating over the hero, the
     lineup or the FAQ — an IntersectionObserver on #tss-build slides it in when the section
     is on screen and out again when it isn't. The `has-dock` bottom padding stays constant
     so the slide never shifts layout.
     NOTE: `has-dock` goes on the .t-ss root, not <body> — the rule is `.t-ss.has-dock`, so
     the old body toggle silently never applied and the dock overlapped the last row. */
  function syncDock(){
    if(!tssRoot) return;
    tssRoot.classList.toggle('has-dock', window.matchMedia('(max-width:860px)').matches);
  }
  syncDock();
  window.addEventListener('resize', syncDock);

  var dockEl = document.getElementById('tss-dock');
  var builderSec = document.getElementById('tss-build');
  if(dockEl && builderSec && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        dockEl.classList.toggle('is-live', en.isIntersecting);
        /* Don't leave a sheet floating over content it doesn't describe. */
        if(!en.isIntersecting){ closeSheet(); }
      });
    }, { rootMargin: '-10% 0px -10% 0px' }).observe(builderSec);
  } else if(dockEl){
    dockEl.classList.add('is-live');
  }

  /* Builder cards ship [hidden] per model tab, so their lazy imgs never prefetch and
     tab switches page into gray tiles. Eager-fetch the whole builder set (incl. swatch
     variant images referenced in data-image) once the shopper scrolls near it. */
  var buildSec = document.getElementById('tss-build');
  if(buildSec && 'IntersectionObserver' in window){
    var bIO = new IntersectionObserver(function(entries){
      for(var i=0;i<entries.length;i++){
        if(entries[i].isIntersecting){
          buildSec.querySelectorAll('img[loading="lazy"]').forEach(function(im){ im.loading='eager'; });
          buildSec.querySelectorAll('[data-sw][data-image]').forEach(function(sw){
            var pre = new Image(); pre.src = sw.dataset.image;
          });
          bIO.disconnect();
          break;
        }
      }
    }, { rootMargin: '600px' });
    bIO.observe(buildSec);
  }

  /* ---------- 7. Secondary-nav scrollspy ---------- */
  var subnav = document.querySelector('[data-subnav]');
  if(subnav){
    var navTabs = Array.prototype.slice.call(subnav.querySelectorAll('.subnav-tab'));
    var setActive = function(tab){
      navTabs.forEach(function(t){ t.classList.toggle('on', t === tab); });
      if(tab && subnav.scrollWidth > subnav.clientWidth){
        try{ tab.scrollIntoView({ behavior:'smooth', inline:'center', block:'nearest' }); }catch(e){}
      }
    };
    navTabs.forEach(function(t){ t.addEventListener('click', function(){ setActive(t); }); });
    if('IntersectionObserver' in window){
      var spyMap = {};
      navTabs.forEach(function(t){
        var id = (t.getAttribute('href')||'').slice(1);
        var sec = id && document.getElementById(id);
        if(sec){ spyMap[id] = t; }
      });
      var spy = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting && spyMap[en.target.id]){ setActive(spyMap[en.target.id]); }
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      Object.keys(spyMap).forEach(function(id){ spy.observe(document.getElementById(id)); });
    }
  }

  /* Seed the model filter from the dropdown's initially-selected option, then paint.
     That option is the FIRST model block — which is also the only one whose cards the
     Liquid renders un-hidden, so JS state and server markup start in agreement. */
  var initialTab = selectedModelOption();
  if(initialTab && initialTab.dataset.model){ applyModel(initialTab); }
  render();
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
